import { Outlet, useParams } from "react-router-dom";
import SidebarNav from "../../components/Settings/SidebarNav";
import { useEffect, useState } from "react";
import { useStateGetter } from "../../hooks/statehooks/UseStateGettersHook";
import { useStateSetter } from "../../hooks/statehooks/UseStateSettersHook";
import { Employees } from "./employee/Employees";
import { Department } from "../settings/department";
import { RxDashboard } from "react-icons/rx";
import { FaInbox, FaUser } from "react-icons/fa";
import { HiOutlineDocumentReport } from "react-icons/hi";
import Postitions from "./employee/Postitions";
import Contracts from "./employee/Contracts";
import LeaveConf from "./employee/Leave/LeaveConf";
import { Leaves } from "./employee/Leaves";
import Calender from "./employee/Configuration/Calender";
import OrganogramViwew from "./employee/OrganogramViwew";
import AppraisalConf from "./employee/Configuration/AppraisalConf";
import { ReactComponent as ConfigIcon } from "../../assets/svgs/configIcon.svg";
import { ReactComponent as DashIcon } from "../../assets/svgs/dashboard.svg";
import { ReactComponent as EmplIcon } from "../../assets/svgs/employeeIcon.svg";
import { ReactComponent as ContIcon } from "../../assets/svgs/contractsIcon.svg";
import { ReactComponent as RepIcon } from "../../assets/svgs/reporticon.svg";
import { ReactComponent as OrganIcon } from "../../assets/svgs/organogramIcon.svg";
import { ReactComponent as GoalsIcon } from "../../assets/svgs/goalsicon.svg";
import { ReactComponent as LeavIcon } from "../../assets/svgs/leaveIcon.svg";
import { ReactComponent as AppIcon } from "../../assets/svgs/appraisal.svg";
import { ReactComponent as Contacticon } from "../../assets/svgs/contacts.svg";
import { ReactComponent as PipelineIcon } from "../../assets/svgs/pipeline.svg";
import { Appraisal } from "./employee/Appraisal";
import { Goals } from "./employee/Goals";
import { useOrganizationHook } from "../../hooks/useOrganizationHook";
import useEmployeeHook from "../../hooks/useEmployeeHook";
import { singlenavabaritem } from "../../typings/uicomponents";
import EmployeeDetailed from "./employee/EmployeeDetailed";
import CRMDashboard from "./crm/CRMDashboard";
import { Activity } from "../home/Activity";
import CRMActivity from "./crm/CRMActivity";
import CRMContacts from "./crm/CRMContacts";
import CRMPipeline from "./crm/CRMPipeline";

export default () => {
  const { moduleId } = useParams();
  const { SidebarRenderView, selectedEmployee } = useStateGetter();
  const { setSidebarRenderView, setSelectedorg, setselectedEmpl } =
    useStateSetter();
  const { UserOrgs } = useOrganizationHook();
  const { orgid } = useParams();
  // To be generated specified by module developer
  const { SelectedOrg, authuser } = useStateGetter();
  const { selectedOrgEmployees } = useEmployeeHook();

  useEffect(() => {
    var sorg = UserOrgs.filter((jk: any) => jk.id == orgid);
    console.log(sorg, "selected org", UserOrgs.length, orgid);
    setSelectedorg(UserOrgs.filter((jk: any) => jk.id == orgid)[0]);
  }, [UserOrgs]);

  const [ModuleCats, setModuleCats] = useState([]);

  const emplmodulenav = [
    {
      title: "Dashboard",
      onclick: () => {
        setSidebarRenderView(<>Dashbaord</>);
      },
      icon: <DashIcon className="inline mr-1" fill="currentColor" stroke="" />,
    },
    {
      title: "Employees",
      onclick: () => {
        setSidebarRenderView(<Employees />);
      },
      icon: <EmplIcon className="inline mr-1" fill="currentColor" stroke="" />,
    },

    {
      title: "Appraisal",
      onclick: () => {
        setSidebarRenderView(<Appraisal />);
      },
      icon: <AppIcon className="inline mr-1" fill="currentColor" stroke="" />,
    },
    {
      title: "Leaves",
      onclick: () => {
        setSidebarRenderView(<Leaves />);
      },
      icon: <LeavIcon className="inline mr-1" fill="currentColor" stroke="" />,
    },
    {
      title: "Contracts",
      onclick: () => {
        setSidebarRenderView(<Contracts />);
      },
      icon: <ContIcon className="inline mr-1" fill="currentColor" stroke="" />,
    },
    {
      title: "Organogram",
      onclick: () => {
        setSidebarRenderView(<OrganogramViwew />);
      },
      icon: <OrganIcon className="inline mr-1" fill="currentColor" stroke="" />,
    },
    {
      title: "Goals",
      onclick: () => {
        setSidebarRenderView(<Goals />);
      },
      icon: <GoalsIcon className="inline mr-1" fill="currentColor" stroke="" />,
    },

    {
      title: "Reports",
      onclick: () => {
        setSidebarRenderView(<>Reports</>);
      },

      icon: <RepIcon className="inline mr-1" fill="currentColor" stroke="" />,
    },
    {
      title: "Configuration",
      onclick: () => {
        //  setSidebarRenderView(<>Configuration</>);
      },
      icon: (
        <ConfigIcon className="inline mr-1" fill="currentColor" stroke="" />
      ),

      children: [
        {
          title: "Position",
          onclick: () => {
            setSidebarRenderView(<Postitions />);
          },
        },
        {
          title: "Department",
          onclick: () => {
            setSidebarRenderView(<Department />);
          },
        },
        {
          title: "Leave",
          onclick: () => {
            setSidebarRenderView(<LeaveConf />);
          },
        },
        {
          title: "Calender",
          onclick: () => {
            setSidebarRenderView(<Calender />);
          },
        },
        {
          title: "Appraisal",
          onclick: () => {
            setSidebarRenderView(<AppraisalConf />);
          },
        },
      ],
    },
  ];
  const contmodulenav = [
    {
      title: "Dashboard",
      onclick: () => {
        setSidebarRenderView(<CRMDashboard />);
      },
      icon: <DashIcon className="inline mr-1" fill="currentColor" stroke="" />,
    },
    {
      title: "Activity",
      onclick: () => {
        setSidebarRenderView(<CRMActivity />);
      },
      icon: <FaInbox className="inline mr-1" fill="currentColor" stroke="" />,
    },

    {
      title: "Contact",
      onclick: () => {
        setSidebarRenderView(<CRMContacts />);
      },
      icon: <Contacticon className="inline mr-1" fill="currentColor" stroke="" />,
    },
    {
      title: "Pipeline",
      onclick: () => {
        setSidebarRenderView(<CRMPipeline />);
      },
      icon: <PipelineIcon className="inline mr-1" fill="currentColor" stroke="" />,
    },
    {
      title: "Team",
      onclick: () => {
        setSidebarRenderView(<Contracts />);
      },
      icon: <ContIcon className="inline mr-1" fill="currentColor" stroke="" />,
    },

    {
      title: "Report",
      onclick: () => {
        setSidebarRenderView(<>Reports</>);
      },

      icon: <RepIcon className="inline mr-1" fill="currentColor" stroke="" />,
    },
    {
      title: "Configuration",
      onclick: () => {
        //  setSidebarRenderView(<>Configuration</>);
      },
      icon: (
        <ConfigIcon className="inline mr-1" fill="currentColor" stroke="" />
      ),

      children: [
        {
          title: "Activity Type",
          onclick: () => {
            setSidebarRenderView(<Postitions />);
          },
        },

        {
          title: "Calender",
          onclick: () => {
            setSidebarRenderView(<Calender />);
          },
        },
      ],
    },
  ];

  useEffect(() => {
    switch (moduleId) {
      case "Employee":
        setModuleCats(emplmodulenav);
        break;
      case "CRM":
        setModuleCats(contmodulenav);
        break;
    }
  }, []);

  var [islinemanagerArr, setislinemanagerArr] = useState<singlenavabaritem[]>(
    []
  );

  useEffect(() => {
    if (authuser.isEmployee) {
      selectedOrgEmployees.map((it: any) => {
        if (it.workEmail == authuser.email) {
          setselectedEmpl(it);
        }
      });
    }
  }, [selectedOrgEmployees]);

  useEffect(() => {
    if (selectedEmployee.isLineManager) {
      setislinemanagerArr([
        {
          title: "Appraisal",
          onclick: () => {
            setSidebarRenderView(<Appraisal />);
          },
          icon: (
            <AppIcon className="inline mr-1" fill="currentColor" stroke="" />
          ),
        },
        {
          title: "Goals",
          onclick: () => {
            setSidebarRenderView(<Goals />);
          },
          icon: (
            <GoalsIcon className="inline mr-1" fill="currentColor" stroke="" />
          ),
        },
      ]);
    }
  }, [selectedEmployee]);

  const empModuleCats = [
    {
      title: "Dashboard",
      onclick: () => {
        setSidebarRenderView(<>Dashbaord</>);
      },
      icon: <RxDashboard className="inline mr-2" />,
    },
    {
      title: "My Info",
      onclick: () => {
        setSidebarRenderView(<Employees />);
      },
      icon: <FaUser className="inline mr-2" />,
    },

    {
      title: "Reports",
      onclick: () => {
        setSidebarRenderView(<>Reports</>);
      },

      icon: <HiOutlineDocumentReport className="inline mr-2 " />,
    },
  ];

  useEffect(() => {
    setSidebarRenderView(<>Dashbaord</>);
  }, []);

  return (
    <div className="h-full w-screen flex mt-4 overflow-y-scroll">
      <div className="w-[30vw] px-14 h-full">
        <SidebarNav
          title={moduleId ? moduleId : "xyz"}
          items={
            authuser.isEmployee
              ? [...empModuleCats, ...islinemanagerArr]
              : ModuleCats
          }
        />
      </div>
      <div className=" w-[70vw]  flex justify-start items-start h-full  ">
        {SidebarRenderView}
      </div>
    </div>
  );
};
export{PipelineIcon}